export const GENDER_OPTIONS = [
  { value: '', label: 'Select option', disabled: true },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
]

export const PROGAMER_OPTIONS = [
  { value: '', label: 'Select option', disabled: true },
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
]

export const DEFAULT_AGE_FILTER_OPTIONS = {
  ageMin: 0,
  ageMax: 100,
}

export const INITIAL_FILTERS_STATE = {
  country: [],
  region: [],
  city: [],
  ageMin: DEFAULT_AGE_FILTER_OPTIONS.ageMin,
  ageMax: DEFAULT_AGE_FILTER_OPTIONS.ageMax,
  language: [],
  gender: [],
  progamer: [],
}

export const TABLE_PAGINATION_SX = {
  borderRadius: '18px',
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  '.MuiTablePagination-toolbar': {
    backgroundColor: '#424243',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '8px 4px',
    minHeight: 'auto',
    '@media (max-width: 991px)': {
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '4px',
      padding: '8px 0',
      minHeight: 'auto',
      width: '100%',
      overflow: 'visible',
      borderRadius: '18px',
    },
  },
  '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
    '@media (max-width: 991px)': {
      fontSize: '11px',
      margin: '0 2px',
      whiteSpace: 'nowrap',
    },
  },
  '.MuiTablePagination-select': {
    '@media (max-width: 991px)': {
      margin: '0 2px',
      fontSize: '11px',
      minWidth: '40px',
    },
  },
  '.MuiTablePagination-actions': {
    '@media (max-width: 991px)': {
      margin: '0',
      flexShrink: '0',
    },
  },
  '.MuiIconButton-root': {
    '@media (max-width: 991px)': {
      padding: '2px',
      margin: '0 1px',
      minWidth: '32px',
      height: '32px',
    },
  },
  '.MuiTablePagination-spacer': {
    '@media (max-width: 991px)': {
      flex: '0 0 8px',
    },
  },
}

export const TABLE_PAGINATION_SELECT_PROPS = {
  MenuProps: {
    sx: {
      '.MuiPaper-root': {
        backgroundColor: '#424243 ',
      },
    },
  },
}
